import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CanActivate, Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class DomainRedirectGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const hostname = window.location.hostname;
    const specialDomain = 'terms.noknok.co';

    if (hostname === specialDomain) {
      // Show terms-and-conditions while keeping URL '/'
      this.router.navigateByUrl('/terms-and-conditions', { skipLocationChange: true });
      return false;
    }

    // For all other domains, redirect to login
    this.router.navigate(['/portal/login']);
    return false; // prevents loading the current '' route
  }

}
